"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BusinessValuationPageFour;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _BusinessValuationFormControls = require("./BusinessValuationFormControls");
var _BusinessValuationRefineModal = _interopRequireDefault(require("./BusinessValuationRefineModal"));
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _BusinessValuationWizardCalc = require("./BusinessValuationWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function BusinessValuationPageFour(_ref) {
  var {
    snapshot,
    refinementHandleClose,
    showRefinement,
    disclosureHandleClose,
    showDisclosure
  } = _ref;
  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values: {
      businessPercent,
      isService,
      ownersAvePrior3YearsAmount,
      businessProfitAvePrior3YearsAmount,
      netBookAmount
    },
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_BusinessValuationWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var disclosureArray = ['This calculator provides a general indication of the value of your business and is not intended to replace a thorough business assessment by an accredited business valuation professional. ', 'This interactive calculator is made available to you as a self-help tool for your independent use and is not intended to provide financial advice. We cannot and do not guarantee its applicability or accuracy in regard to your individual circumstances. Examples are for illustrative purposes. We encourage you to seek personalized advice from a qualified financial professional regarding all personal finance issues. MassMutual will assume no liability for the use of or reliance on this calculator.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York.'];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Many business owners can't afford to buy out a significant portion of their shared business if a business partner becomes disabled for an extended period of time. Fortunately, there are ways to protect ownership value in the event of a partner's disability.")), /*#__PURE__*/_react.default.createElement("h4", null, "The value of your share of the business is ", businessPercent, "% "), /*#__PURE__*/_react.default.createElement("h3", {
    className: "data-lg"
  }, isService === 'service' && (0, _BusinessValuationFormControls.businessShareFormulaService)(ownersAvePrior3YearsAmount, businessProfitAvePrior3YearsAmount, netBookAmount, businessPercent), isService === 'nonservice' && (0, _BusinessValuationFormControls.businessShareFormulaNonService)(ownersAvePrior3YearsAmount, businessProfitAvePrior3YearsAmount, netBookAmount, businessPercent)), /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body flat-card-total-business-results-box"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row",
    id: "totalBusinessValue"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm col-md-6"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Total Business Value")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "col col-sm col-md-3"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "business-value-total"
  }, isService === 'service' && (0, _BusinessValuationFormControls.totalBusinessValService)(ownersAvePrior3YearsAmount, businessProfitAvePrior3YearsAmount, netBookAmount), isService === 'nonservice' && (0, _BusinessValuationFormControls.totalBusinessValNonService)(ownersAvePrior3YearsAmount, businessProfitAvePrior3YearsAmount, netBookAmount)))))), /*#__PURE__*/_react.default.createElement(_BusinessValuationRefineModal.default, {
    show: showRefinement,
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot
  }), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    textArray: disclosureArray,
    handleClose: disclosureHandleClose,
    show: showDisclosure
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "blank-spacer"
  }));
}